import React from 'react';
import { isEmpty } from '../lib/Helper';

type ToggleProps = {
    checkedLabel?: string,
    uncheckedLabel?: string,
    isChecked: boolean,
    onToggle: () => void,
};

const ToggleButton = ({ checkedLabel, uncheckedLabel, isChecked, onToggle }: ToggleProps) => {
    return (
        <div className='relative'>
            <label className='themeSwitcherTwo relative inline-flex cursor-pointer select-none items-center'>
                <input
                    type='checkbox'
                    checked={isChecked}
                    onChange={onToggle}
                    className='sr-only'
                />
                {!isEmpty(checkedLabel) && !isEmpty(uncheckedLabel) ? (
                    <>
                        <span className='label flex items-center text-sm font-medium text-black'>
                            {uncheckedLabel}
                        </span>
                        <span className={`slider mx-4 flex h-8 w-[60px] items-center rounded-full p-1 duration-200 ${isChecked ? 'bg-primary-blue' : 'bg-primary-gray'}`}>
                            <span className={`dot h-6 w-6 rounded-full bg-white duration-200 ${isChecked ? 'translate-x-[28px]' : ''}`}></span>
                        </span>
                        <span className='label flex items-center text-sm font-medium text-black'>
                            {checkedLabel}
                        </span>
                    </>
                ) : (
                    <>
                        <div className={`box block h-8 w-14 rounded-full ${ isChecked ? 'bg-primary-blue' : 'bg-primary-gray' }`}></div>
                        <div className={`absolute left-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-white transition ${ isChecked ? 'translate-x-full' : '' }`}></div>
                    </>
                )}
            </label>
        </div>
    )
}

export default ToggleButton
